module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-lastampa.960e434ce6b2a52a90eede2f374addd4.png";